import React from "react";
import { Stack } from "@origin-digital/ods-core";
import { useNavigate } from "react-router-dom";
import { RequestCounts } from "../types";
import NavItemBelowLg from "../NavItem/NavItem.belowLg";
import { useNavSection } from "./useNavSection";

type NavSectionBelowLgProps = {
  toggleDrawer: (newOpen: boolean) => () => void;
};

const NavSectionBelowLg = ({ toggleDrawer }: NavSectionBelowLgProps) => {
  const { counts, navContent, logout, isAuthenticated } = useNavSection();
  const navigate = useNavigate();
  if (!isAuthenticated) {
    return <> </>;
  }
  return (
    <>
      <Stack space="none">
        {navContent.map((navItem) => {
          const count =
            counts[navItem.routes[0].replace("/", "") as keyof RequestCounts];
          return (
            <NavItemBelowLg
              key={navItem.title}
              title={navItem.title}
              routes={navItem.routes}
              count={count}
              handleClick={() => {
                navigate(navItem.routes[0]);
                toggleDrawer(false)();
              }}
            />
          );
        })}
        <NavItemBelowLg
          key="logout"
          title="Log out"
          routes={["/logout"]}
          count={0}
          handleClick={() => {
            logout();
            toggleDrawer(false)();
          }}
        />
      </Stack>
    </>
  );
};

export default NavSectionBelowLg;
